<div class="desktop-only-container">
  <main class="px-8 pb-8 pt-4">
    <h1 class="es-h1 mt-4 text-center">Oops!</h1>
    <p class="font-semibold text-center mt-4 mb-4">Your policy is not eligible for online services at this time.</p>
    <p class="text-center px-38">Questions? Please<a target="_blank"
        class="text-es-blue hover:underline font-semibold cursor-pointer"
        href="https://www.plymouthrock.com/contact-us"> Contact Us. </a></p>
  </main>
</div>
